
"use client";
import React from "react";
import { useState, useContext, useEffect, useRef, useMemo } from "react";
import { Buttons } from "../../../../components/ui/button";
import { Badge } from "../../../../components/ui/badge";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../../../components/ui/tabs";
import BtnClickSound from "../../../../assets/adiuo/simple-btn-click.mp3";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../components/ui/table";
import { ChevronLeft, ChevronRight } from "lucide-react";
import svgPaths from "../../../../imports/svg-knollny4nu";
import {
  CustomCoinIcon,
  CustomHomeIcon,
  CustomMapIcon,
  CustomRankingIcon,
  CustomSettingsIcon,
} from "../../../../components/ui/CustomIcons";
// import imgBackground from "/images/background.png";
import { useColor } from "../../../../components/ui/ColorContext";
import ColorPicker from "../../../../components/ui/ColorPicker";
import { Slider } from "../../../../components/ui/slider";
import { Dialog, DialogContent, DialogTrigger } from "../../../../components/ui/dialog";
// import { ReplayDialog } from "./ReplayDialog";
import { motion } from "framer-motion";
import { getLeaderboardData } from "utils/gameApplication/gamePlayService";
import { useParams } from "react-router-dom";
import { activityUpdate } from "utils/gameApplication/gameActivityService";
import { createOrUpdateStoryBlock } from "../common";
import { ScoreContext } from "../GamePreview";

// Helper function to convert hex to RGB
const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return "0, 255, 187"; // fallback to default green
  const r = Number.parseInt(result[1], 16);
  const g = Number.parseInt(result[2], 16);
  const b = Number.parseInt(result[3], 16);
  return `${r}, ${g}, ${b}`;
};

// Moved NavigationArrow outside to prevent recreation
const NavigationArrow: React.FC<{
  direction: "left" | "right";
  onClick: () => void;
  primaryColor: string;
}> = React.memo(({ direction, onClick, primaryColor }) => {
  const primaryColorRgb = hexToRgb(primaryColor);
  
  return (
    <Buttons
      variant="ghost"
      size="sm"
      onClick={onClick}
      className="w-[3.75rem] h-10 py-2 px-4 rounded-3xl transition-all duration-200 hover:scale-110"
      style={{
        background: `linear-gradient(${
          direction === "left" ? "275.041deg" : "90deg"
        },
              rgba(${primaryColorRgb}, 0.6) 7.25%, rgba(${primaryColorRgb}, 0.15) 84.803%)`,
        border: `1px solid ${primaryColor}`,
        boxShadow: `0px 0px 15.9542px 0px rgba(${primaryColorRgb}, 0.3)`,
      }}
    >
      {direction === "left" ? (
        <ChevronLeft className="!h-4 !w-4 text-white" />
      ) : (
        <ChevronRight className="!h-4 !w-4 text-white" />
      )}
    </Buttons>
  );
});

const ScenarioLeaderboard: React.FC<{
  AssignId?:any;
  setData:any;
  setOptions:any;
  Activitydata?:any;
  seconds?:any;
  questState?:any;
  onCompletionDone:any;
  sceneriowiseHighestEarnedScore: any;
  onNavigate?: (direction: "left" | "right") => void;
  formData?: any;
  handleScenarioReplayButtonClick:any;
    sceneriowiseEarnedScore:any;
    scenarioTotalScore:any;
    scenarioAllTimeScore:any;
  imageSrc?: any;
  getData?: any;
  data?: any;
  setType:any;
  homeLeaderBoard?: any;
  setHomeLeaderBoard?: any;
  setCurrentScreenId?: any;
  gameInfo?: any;
  preloadedAssets: any;
  setPlayerTodayScore: any;
  playerTodayScore: any;
  setCurrentQuestNo: any;
  setFirstLoading: any;
  learnerPlayList: any;
  profile?: any;
  setProfile?: any;
  useData?: any;
  onLeaderboardBack?:any
  setAnimateNote:any;
  setShowScenarioLeaderboard:any;
  setIsPopupNextFlow?:any;
  upNext :any;
  // AllLearnerLearderboard:any;
  setAllLearnerScenarioScore:any;
  allLearnerScenarioScore:any;
  scenariowisebestscore1:any;
}> = React.memo(({
   AssignId,
   setData,
  setOptions,
  Activitydata,
  seconds,
  questState,
   sceneriowiseHighestEarnedScore,
  onCompletionDone,
  handleScenarioReplayButtonClick,
    sceneriowiseEarnedScore,
    scenarioTotalScore,
    scenarioAllTimeScore,
     
    scenariowisebestscore1,
  onNavigate,
  setIsPopupNextFlow,
  formData,
  imageSrc,
  getData,
  data,
    setType,
  setCurrentScreenId,
  homeLeaderBoard,
  setHomeLeaderBoard,
  gameInfo,
  preloadedAssets,
  setPlayerTodayScore,
  playerTodayScore,
  setCurrentQuestNo,
  setFirstLoading,
  learnerPlayList,
  profile,
  setProfile,
  useData,
  onLeaderboardBack,
  setAnimateNote,
  setShowScenarioLeaderboard,
  upNext,
  // AllLearnerLearderboard,
  setAllLearnerScenarioScore,
  allLearnerScenarioScore,
}) => {
  const { setlearnerActivityrec ,deviceInfo} = useContext(ScoreContext);
  const bestAllTimeScore = Array.isArray(scenarioAllTimeScore)
    ? Math.max(
        ...scenarioAllTimeScore.filter(
          (s: number) => typeof s === 'number' && s > 0
        ),
        0
      )
    : 0;

  // final score used for stars & competency
  const effectiveScore =
    bestAllTimeScore > 0
      ? Math.min(bestAllTimeScore, scenarioTotalScore)
      : sceneriowiseEarnedScore;

  
  const [minimumScore,setminimumScore] = useState(data.scMinPassScore)
 
  useEffect(()=>{
    setminimumScore(data.scMinPassScore)
  },[data])

  const [showReplayPopup, setShowReplayPopup] = useState(false);
  const earnedScore = sceneriowiseEarnedScore;
const totalScore = scenarioTotalScore;
const minScore = minimumScore;
 const totalScore1 = scenariowisebestscore1;
const remainingToMin = Math.max(minScore - earnedScore, 0);


const remainingToFull = Math.max(totalScore - totalScore1, 0);

  const isBelowMin = totalScore1 < minScore;
  const isPerfectScore = totalScore1 === totalScore;
const getPopupMessage = () => {
 
  if (isBelowMin) {
    return `You need to earn ${minScore - totalScore1} more points to reach the minimum score. Replay is required.`;
  }

  if (isPerfectScore) {
    return `Would you like to replay this scenario?`;
  }

  return `You’re almost there! Earn ${remainingToFull} more points to achieve a perfect score.`;
};
const scenarioSource =
  data?.blockScenario || data?.scScenarioLevel;

const scenarioNumber =
  typeof scenarioSource === "string"
    ? Number(scenarioSource.replace(/\D/g, ""))
    : scenarioSource;

const isScenarioOne = scenarioNumber === 1;


useEffect(() => {
  setShowReplayPopup(false);
}, [scenarioSource]);






//new bya kaviya 

const audioCtxRefreview = useRef<AudioContext | null>(null);
  const audioCtxRef = useRef<AudioContext | null>(null);
  function playLeaderboard(ctx: AudioContext) {
  const now = ctx.currentTime;
  [2200, 1760, 1320, 1100, 880].forEach((freq, i) => {
    const t = now + i * 0.07;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(freq, t);
    gain.gain.setValueAtTime(0, t);
    gain.gain.linearRampToValueAtTime(0.1, t + 0.008);
    gain.gain.exponentialRampToValueAtTime(0.001, t + 0.35);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(t);
    osc.stop(t + 0.36);
  });
}
  useEffect(() => {
    if (!audioCtxRef.current) {
      audioCtxRef.current = new (window.AudioContext || (window as any).webkitAudioContext)();
    }

    if (audioCtxRef.current.state === "suspended") {
      audioCtxRef.current.resume();
    }

    // Play the leaderboard sound when component mounts
    playLeaderboard(audioCtxRef.current);
  }, []);



  
  function playMenuAndNext(ctx: AudioContext) {
  const now = ctx.currentTime;
  [520, 780].forEach((freq, i) => {
    const t = now + i * 0.06;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(freq, t);
    gain.gain.setValueAtTime(0, t);
    gain.gain.linearRampToValueAtTime(0.15, t + 0.005);
    gain.gain.linearRampToValueAtTime(0, t + 0.05);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(t);
    osc.stop(t + 0.06);
  });
}
  const menuAudioCtxRef = useRef<AudioContext | null>(null);
  
  function playMenuSound() {
    if (!menuAudioCtxRef.current) {
      menuAudioCtxRef.current = new (window.AudioContext || (window as any).webkitAudioContext)();
    }
  
    if (menuAudioCtxRef.current.state === "suspended") {
      menuAudioCtxRef.current.resume();
    }
  
    playMenuAndNext(menuAudioCtxRef.current);
  }
  

// Next arrow click
// const handleNextClick = () => {
//   setShowReplayPopup(true);
// };
const handleNextClick = () => {
     const blockdata = {
          blockId: data.blockId,
          blockGameId: data.blockGameId,
          blockQuestNo: data.blockQuestNo,
          blockScenario: data.blockScenario,
          blockSecondaryId: data.blockSecondaryId,
          blockPrimarySequence: data.blockPrimarySequence,
          blockDragSequence: data.blockDragSequence,
          blockShowNavigate: data.blockShowNavigate,
          blockLeadTo: data.blockLeadTo,
          blockChoosen: data.blockChoosen,
    }
    setlearnerActivityrec((prev:any)=>
      createOrUpdateStoryBlock(
        prev,
        {
          ...blockdata,
          replyPromptopen:true,
          replyPromptclose:false,
          promptscenario : isBelowMin ? 'mandatoryReplay' : 'optionalReplay',
          replayplayaction : false
        },
        deviceInfo
      )
    );
  if (isScenarioOne) {
    setShowReplayPopup(true);
    return;
  }
  else if (!isScenarioOne) {
    setType('ScenarioCompletion22');
    setShowScenarioLeaderboard(false);
  }

  onScenarioLeaderboardNext();
};

const shouldShowReplayPopup =
  isScenarioOne && showReplayPopup;


  //new by kaviya 
function playScenarioReview(ctx: AudioContext) {
  const now = ctx.currentTime;
  [528, 660].forEach((freq, i) => {
    const t = now + i * 0.1;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(freq, t);
    gain.gain.setValueAtTime(0, t);
    gain.gain.linearRampToValueAtTime(0.15, t + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.001, t + 0.2);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(t);
    osc.stop(t + 0.22);
  });
}

useEffect(() => {
  if (shouldShowReplayPopup) {

    if (!audioCtxRefreview.current) {
      audioCtxRefreview.current = new (window.AudioContext || (window as any).webkitAudioContext)();
    }

    if (audioCtxRefreview.current.state === "suspended") {
      audioCtxRefreview.current.resume();
    }

    playScenarioReview(audioCtxRefreview.current);
  }
}, [shouldShowReplayPopup]);





// Replay from popup



    const playClickSound = () => {
              try {
                const audio = new Audio(BtnClickSound as string);
                audio.volume = 1;
                audio.play().catch(() => { });
        
                setTimeout(() => {
                  audio.pause();
                  audio.currentTime = 0;
                }, 1000);
              } catch (e) {
                // ignore audio errors
              }
            };

  const { primaryColor } = useColor();
  const primaryColorRgb = useMemo(() => hexToRgb(primaryColor), [primaryColor]);


  
  const [selectedTab, setSelectedTab] = useState<"department" | "overall">("overall");
  const [isReplayDialogOpen, setIsReplayDialogOpen] = useState(false);
  const { learner_game_play_id } = useParams();
  
  // State from original component
  const [shuffledUsers, setShuffledUsers] = useState<any[]>([]);
  const [allTimeClicked, setAllTimeClicked] = useState(false);
  const [newSortedUserss, setNewSortedUserss] = useState<any[]>([]);
  const [sortedUsers, setSortedUsers] = useState<any[]>([]);
  const [sortAse, setSortAse] = useState({ daily: true, allTime: true });
  const [departmentLeaderboardData, setDepartmentLeaderboardData] = useState<any[]>([]);
  const [companyLeaderboardData, setCompanyLeaderboardData] = useState<any[]>([]);
  
  const containerRef = useRef<any>(null);
  let lastScrollTop = 0;

  // Fetch leaderboard data
  // useEffect(() => {
  //   const getAllLearnerScores = async () => {
  //     const getLeaderboardDatas = await getLeaderboardData(learner_game_play_id);
  //     if (getLeaderboardDatas?.departmentLeaderboardData) {
  //       setDepartmentLeaderboardData(getLeaderboardDatas?.departmentLeaderboardData);
  //     }
  //     if (getLeaderboardDatas?.companyLeaderboardData) {
  //       setCompanyLeaderboardData(getLeaderboardDatas?.companyLeaderboardData);
  //     }
  //   };
  //   getAllLearnerScores();
  // }, [learner_game_play_id]);


const isPopupActionRef = useRef(false);
  const hasFetchedRef = useRef(false);

useEffect(() => {
   if (!learner_game_play_id || hasFetchedRef.current) return;

  const getAllLearnerScores = async () => {
    const getLeaderboardDatas = await getLeaderboardData(learner_game_play_id);

    if (getLeaderboardDatas?.departmentLeaderboardData) {
      setDepartmentLeaderboardData(getLeaderboardDatas.departmentLeaderboardData);
    }

    if (getLeaderboardDatas?.companyLeaderboardData) {
      setCompanyLeaderboardData(getLeaderboardDatas.companyLeaderboardData);
    }
  };

  getAllLearnerScores();

  hasFetchedRef.current = true;

}, [learner_game_play_id]);
// ==================================================
// ## HELPER: Get MAX score from allTimeScore array
// ==================================================
const getMaxScoreFromArray = (arr: number[] = []) => {
  if (!Array.isArray(arr) || arr.length === 0) return 0;
  return Math.max(...arr);
};


const todayDate = useMemo(() => {
  const d = new Date();
  return `${String(d.getDate()).padStart(2, "0")}-${String(
    d.getMonth() + 1
  ).padStart(2, "0")}-${d.getFullYear()}`;
}, []);

// ==================================================
// ✅ DAILY SCORE = MAX(allTimeScore) (NO DATE FILTER)
// ==================================================
const currentLearnerId = gameInfo?.learnerDetails?.lenId;

const orderedLearnerList = useMemo(() => {

  if (!allLearnerScenarioScore?.length) return [];

  const loginId = Number(currentLearnerId);

  const currentUser = allLearnerScenarioScore.find(
    (item: any) => Number(item?.learnerId) === loginId
  );

  const remainingUsers = allLearnerScenarioScore.filter(
    (item: any) => Number(item?.learnerId) !== loginId
  );

  return currentUser
    ? [currentUser, ...remainingUsers]
    : allLearnerScenarioScore;

}, [allLearnerScenarioScore, currentLearnerId]);
const dailyScoreByLearner = useMemo(() => {
  const map: Record<number, number> = {};

  allLearnerScenarioScore?.forEach((item: any) => {
    map[item.learnerId] = getMaxScoreFromArray(item.allTimeScore);
  });

  return map;
}, [allLearnerScenarioScore]);



// ==================================================
// ✅ POSITION = Rank based on MAX(allTimeScore)
// ==================================================
const positionByLearner = useMemo(() => {
  const sorted = allLearnerScenarioScore
    ?.map((item: any) => ({
      learnerId: item.learnerId,
      score: getMaxScoreFromArray(item.allTimeScore),
    }))
    .sort((a: any, b: any) => b.score - a.score);

  const posMap: Record<number, number> = {};
  sorted?.forEach((item: any, index: number) => {
    posMap[item.learnerId] = index + 1;
  });

  return posMap;
}, [allLearnerScenarioScore]);


  const currentScenario = data?.scenario;
const currentQuestNo = data?.questNo;
// ==================================================
// ## ALL TIME SCORE = MAX(allTimeScore) (any date)
// ==================================================
const overallScoreByLearner = useMemo(() => {
  const map: Record<number, number> = {};

  allLearnerScenarioScore?.forEach((item: any) => {
    map[item.learnerId] = getMaxScoreFromArray(item.allTimeScore);
  });

  return map;
}, [allLearnerScenarioScore]);





  // Calculate player today score
  useEffect(() => {
    const currentDate = new Date();
    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const year = currentDate.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;

    const scores = profile?.score;
    const sums: any = {};
    scores?.forEach((score: any) => {
      const quest = score.quest;
      if (!sums[quest]) {
        sums[quest] = 0;
      }
      if (score.scoreEarnedDate === formattedDate) {
        sums[quest] += score.score;
      }
    });

    let getFinalscores = {};
    Object.entries(sums).forEach(([quest, score]) => {
      const IntQuest = parseInt(quest);
      const newQuest = { ...getFinalscores, [IntQuest]: score };
      getFinalscores = { ...newQuest };
    });

    const Replayscores = profile?.replayScore?.length > 0 ? profile?.replayScore : null;
    const Replaysums: { [key: number]: number } = {};
    Replayscores?.forEach((score: any) => {
      const quest = score.quest;
      if (!Replaysums[quest]) {
        Replaysums[quest] = 0;
      }
      if (score.scoreEarnedDate === formattedDate) {
        Replaysums[quest] += score.score;
      }
    });

    let getReplayFinalscores: { [key: number]: number } = {};
    Object.entries(Replaysums).forEach(([quest, score]) => {
      const IntQuest = parseInt(quest);
      getReplayFinalscores = { ...getReplayFinalscores, [IntQuest]: score };
    });

    const TodayTotalScore = Object.entries(getFinalscores).reduce((tot: number, acc: any) => {
      let questNo = acc[0];
      let questHasReplay = Object.keys(getReplayFinalscores).some((quest) => quest === questNo);
      if (questHasReplay) {
        getReplayFinalscores[questNo] > acc[1] ? (tot += getReplayFinalscores[questNo]) : (tot += acc[1])
      }
      else {
        tot += acc[1];
      }
      return tot;
    }, 0);
    setPlayerTodayScore(TodayTotalScore);
  }, [playerTodayScore, profile, setPlayerTodayScore]);

  // Process leaderboard data
  const leaderboardToRender = useMemo(() => {
    const currentBoard = selectedTab === "department" ? departmentLeaderboardData : companyLeaderboardData;
    const data = Array.isArray(currentBoard) ? currentBoard.slice() : [];

    // Map scores to positions (daily)
    const dailySorted = data.slice().sort((a, b) => (b.score ?? 0) - (a.score ?? 0));
    const dailyPos = new Map<number | string, number>();
    dailySorted.forEach((item, idx) => {
      const key = item.learnerId ?? item.name ?? idx;
      dailyPos.set(key, idx + 1);
    });

    // Map allTimeScore to positions (all time)
    const alltimeSorted = data.slice().sort((a, b) => (b.allTimeScore ?? 0) - (a.allTimeScore ?? 0));
    const alltimePos = new Map<number | string, number>();
    alltimeSorted.forEach((item, idx) => {
      const key = item.learnerId ?? item.name ?? idx;
      alltimePos.set(key, idx + 1);
    });

    // Attach positions
    const augmented = data.map((item, idx) => {
      const key = item.learnerId ?? item.name ?? idx;
      return {
        ...item,
        dailyPosition: dailyPos.get(key) ?? idx + 1,
        alltimePosition: alltimePos.get(key) ?? idx + 1,
      };
    });

    // Order by daily score for display (highest first)
    const ordered = augmented.slice().sort((a, b) => (b.score ?? 0) - (a.score ?? 0));

  // Move current player to top (if needed)
  const playerName =
    learnerPlayList?.LearnerProfile?.nickName ??
    learnerPlayList?.LearnerProfile?.name;

  if (playerName) {
    const playerIndex = ordered.findIndex(it => it.name === playerName);
    if (playerIndex > -1) {
      const [playerRow] = ordered.splice(playerIndex, 1);
      ordered.unshift(playerRow);
    }
  }

    return ordered;
  }, [selectedTab, departmentLeaderboardData, companyLeaderboardData, learnerPlayList]);

  // Scroll handling
  useEffect(() => {
    const container = containerRef?.current;
    if (!container) return;

    const handleScroll = () => {
      let currentScrollTop = container?.scrollTop;

      if (currentScrollTop > lastScrollTop) {
        container.classList.add('scrollbar-down');
      } else {
        container.classList.remove('scrollbar-down');
      }

      lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
    };

    container.addEventListener('scroll', handleScroll);

    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Navigation handlers from original component
  const handleHome = () => {
    playClickSound();
    if (homeLeaderBoard) {
      setCurrentScreenId?.(homeLeaderBoard);
      setHomeLeaderBoard?.(null);
    } else {
      if (gameInfo) {
        if (
          gameInfo?.gameData?.gameIsShowReflectionScreen === 'true' &&
          gameInfo?.reflectionQuestions.length > 0
        ) {
          setCurrentScreenId?.(3); // Navigate to Reflection screen
        } else if (gameInfo?.gameData?.gameIsShowTakeaway === 'true') {
          setCurrentScreenId?.(7); // Navigate to Takeaway screen
        } else {
          setCurrentScreenId?.(5); // Navigate to Thank you screen
        }
      }
    }
  };



  const previousNavigation = async () => {
    const LastquestNo = parseInt(profile?.currentQuest);
    setCurrentQuestNo?.(LastquestNo);
    setCurrentScreenId?.(6);
  };


  const handleRightNavigation = () => {
      playClickSound();
    onNavigate?.("right");
  };



   const onScenarioLeaderboardBack = () => {
   playClickSound();
 onLeaderboardBack?.();   // UI back only

};





 const onScenarioLeaderboardNext = () => {
  
   playClickSound();

   // IMPORTANT: first close leaderboard
   setShowScenarioLeaderboard(false);

  setTimeout(() => {
  
    upNext();  // OLD LOGIC
   }, 0);
 };

 


  const handleReplayNext = () => {
    handleRightNavigation();
    setIsReplayDialogOpen(false);
  };

  // Tab change handlers
   const isDepartmentEmpty = departmentLeaderboardData.length === 0;
  const handleDepartmentClick = () => {
    if (departmentLeaderboardData.length > 0) {
      setSelectedTab("department");
    }
  };

  const handleOverallClick = () => {
    setSelectedTab("overall");
  };


// const handlePopupNext = () => {
//   setShowReplayPopup(false);
//   onScenarioLeaderboardNext(); // existing next flow
// };

 const handlePopupNext = async() => {
    setIsPopupNextFlow(true);
        const blockdata = {
            blockId: data.blockId,
            blockGameId: data.blockGameId,
            blockQuestNo: data.blockQuestNo,
            blockScenario: data.blockScenario,
            blockSecondaryId: data.blockSecondaryId,
            blockPrimarySequence: data.blockPrimarySequence,
            blockDragSequence: data.blockDragSequence,
            blockShowNavigate: data.blockShowNavigate,
            blockLeadTo: data.blockLeadTo,
            blockChoosen: data.blockChoosen,
      }
      setlearnerActivityrec((prev:any)=>
        createOrUpdateStoryBlock(
          prev,
          {
            ...blockdata,
            replyPromptclose:true,
            promptscenario : isBelowMin ? 'mandatoryReplay' : 'optionalReplay',
            replayplayaction : false
          },
          deviceInfo
        )
      );
  setType('ScenarioCompletion22');
  setShowReplayPopup(false);
  setShowScenarioLeaderboard(false);
  // ✅ tell parent: ScenarioCompletion is finished
  onCompletionDone?.();
        let total = 0;
     
    let updatedscore: any = [];
    if (questState[parseInt(profile?.currentQuest)] === 'Started') {
      // Remove matching object from profile?.score
      updatedscore = profile?.score;
    } else if (
      questState[parseInt(profile?.currentQuest)] === 'replayallowed'
    ) {
      // Remove matching object from profile?.replayScore
      updatedscore = profile?.replayScore;
    } else {
      updatedscore = profile?.score;
    }
    const scoreArray = updatedscore;

  
    if (scoreArray?.length > 0) {

   
      // STEP 2: Apply filter with logs
      const filteredData = scoreArray?.filter((cur: any, index: number) => {
        const isValidStructure =
          cur.seqId &&
          cur.scenarioId !== undefined &&
          cur.choosedoption !== undefined;
  
        const isQuestMatch = Number(cur.quest) === Number(profile.currentQuest);
  
        const finalResult = isValidStructure && isQuestMatch;
  
        return finalResult;
      });

      // STEP 3: Reduce with logs
      total = filteredData?.reduce((sum: number, cur: any, index: number) => {
        const score = Number(cur.score || 0);
  
        return sum + score;
      }, 0);
    }
    const currentQuest = data
      ? parseInt(data?.blockPrimarySequence.split('.')[0])
      : null;
    const quest = data ? data?.blockPrimarySequence.split('.')[0] : null;
    const demoBlocks = gameInfo?.blocks;
 
    let upcomingBlock;
    const selectedNext = Object.keys(demoBlocks[currentQuest])
              .filter((item: any) => {
                return (
                  demoBlocks[currentQuest][item]?.blockSecondaryId ===
                  parseInt(data?.blockLeadTo)
                );
              })
              .map((item: any) => {
                return demoBlocks[currentQuest][item];
              });
        // ✅ manually selected block
        if (selectedNext && selectedNext.length > 0) {
          upcomingBlock = selectedNext[0];
        }else{
             upcomingBlock =  data;
          
        }
    const updatedata = {
      galAssignedId:AssignId,
      blockname: upcomingBlock.blockChoosen,
      galAverageScore: total,
      galBlockId: upcomingBlock.blockSecondaryId,
      galblockleft : upcomingBlock.blockSecondaryId,
      galTimeSpent: seconds,
      gameId: learner_game_play_id,
    };
    const actId1 = Activitydata;
    const datas = JSON.stringify(updatedata);
    const result = await activityUpdate(datas, actId1);
    if (result.status !== 'Success') {
      return false;
    }
  setShowScenarioLeaderboard(false);

  // ✅ tell parent: ScenarioCompletion is finished
  onCompletionDone?.();
  setData(upcomingBlock)
  setType(upcomingBlock?.blockChoosen)
   if (upcomingBlock?.blockChoosen === 'Interaction') {
      const optionsFiltered = [];
      for (const option of gameInfo.questOptions) {
          if (
            option?.qpSequence ===
            upcomingBlock?.blockPrimarySequence
          ) {
            optionsFiltered.push(option);
          }
      }
      if (gameInfo?.gameData?.gameShuffle === 'true') {
        for (let i = optionsFiltered.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [optionsFiltered[i], optionsFiltered[j]] = [
            optionsFiltered[j],
            optionsFiltered[i],
          ];
        }
      }
      setOptions(optionsFiltered);
    }
  // getData(data)
};



  return (
    <motion.div 
      initial={{ rotateY: 180, y: -100 }} 
      animate={{ rotateY: 0, y: 0 }} 
      transition={{ type: 'spring', duration: 1 }}
      className="w-full h-full"
    >
      <div
        className="relative w-full h-screen overflow-hidden bg-center bg-cover "
        // style={{ backgroundImage: `url('${imgBackground}')` }}
      >
        <div className="w-full px-4 sm:px-6 lg:px-8 pb-4   relative h-full flex">
          {/* Top Navigation Bar */}
          <div className="absolute top-0 left-0 right-0 h-[5.5rem] flex items-center justify-between bg-cover bg-center bg-no-repeat px-4 sm:px-6 lg:px-8">
            <div className="flex items-center gap-6">
             
            </div>
            <div className="flex items-center gap-4">
             
              <Dialog>
                <DialogTrigger asChild>
                  <div className="translate-y-1">
                  
                  </div>
                </DialogTrigger>
                <DialogContent
                  className="sm:max-w-2xl rounded-2xl px-7 py-6 border-none shadow-lg"
                  style={{
                    background: `linear-gradient(151.477deg, rgb(0,0,0) 17.606%, rgba(${primaryColorRgb}, 0.6) 218.68%)`,
                    border: `1px solid linear-gradient(151.477deg, rgb(0, 0, 0) 17.606%, rgba(${primaryColorRgb}, 0.4) 188.68%)`,
                    boxShadow: "0px 0px 23.4px 0px rgba(0, 0, 0, 0.50)",
                  }}
                >
                  <h2
                    className="text-center text-3xl py-1 font-medium"
                    style={{
                      color: primaryColor,
                      textShadow: `0 0 9px rgba(${primaryColorRgb}, 0.49)`,
                    }}
                  >
                    Settings
                  </h2>

                  {/* Decorative Line */}
                  <div className="flex items-center justify-center relative w-full">
                    <div className="w-full">
                      <div className="h-[1px] relative w-full">
                        <div
                          className="absolute inset-0"
                          style={{
                            background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                            opacity: 0.995,
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col gap-8 mt-3 mb-2 max-w-md mx-auto w-full pt-5 pb-3">
                    <div className="flex flex-col gap-10">
                      {/* Music Volume */}
                      <div className="flex flex-col gap-1 items-center">
                        <label className="text-2xl font-rubik mb-2 text-white font-normal tracking-normal">
                          Music Volume
                        </label>
                        <Slider
                          defaultValue={[40]}
                          max={100}
                          step={1}
                          className="w-full"
                        />
                      </div>
                      {/* Voice Over Volume */}
                      <div className="flex flex-col gap-1 items-center">
                        <label className="text-2xl font-rubik mb-2 text-white font-normal tracking-[-0.005rem]">
                          Voice over volume
                        </label>
                        <Slider
                          defaultValue={[20]}
                          max={100}
                          step={1}
                          className="w-full"
                        />
                      </div>
                      {/* Color Picker */}
                      <div className="flex flex-col gap-1 items-center">
                        <label className="text-2xl font-rubik mb-2 text-white font-normal tracking-[-0.005rem]">
                          Set Theme
                        </label>
                        <ColorPicker />
                      </div>
                    </div>

                    {/* Okay button */}
                    <DialogTrigger asChild>
                      <Buttons
                        variant="ghost"
                        size="sm"
                        className="w-[5.75rem] text-lg h-11 py-2 px-4 rounded-4xl transition-all duration-200 hover:scale-110 text-white hover:text-white mx-auto"
                        style={{
                          background: `linear-gradient(275.041deg, rgba(${primaryColorRgb}, 0.7) 7.25%, rgba(3, 51, 38, 0.8) 84.803%)`,
                          border: `1px solid ${primaryColor}`,
                          boxShadow: `0px 0px 15.9542px 0px rgba(3, 51, 38, 0.8)`,
                        }}
                      >
                        Okay
                      </Buttons>
                    </DialogTrigger>
                  </div>
                </DialogContent>
              </Dialog>
            </div>
          </div>

          {/* Leadership Content */}
          <div className="h-full flex-grow flex flex-col items-center justify-center pt-[7.25rem]">
            <div
              className="flex flex-col gap-5 bottom-[40px] max-h-fit max-w-7xl overflow-hidden h-full w-full items-center justify-start rounded-[2.375rem] relative px-10 md2x:pt-8 md2x:pb-8 pt-6 pb-6 backdrop-blur-3xl"
              style={{
                background: `linear-gradient(21deg, rgba(${primaryColorRgb}, 0.05) -10.76%, rgba(${primaryColorRgb}, 0.1) 127.18%)`,
              }}
            >
              {/* Leaderboard Title */}
              <div className="relative">
                <h1
                  className="text-4xl font-normal tracking-normal text-center"
                  style={{
                    color: primaryColor,
                    textShadow: `rgba(${primaryColorRgb}, 0.5) 0px 0px 9px`,
                  }}
                >
                  Leaderboard
                </h1>
              </div>

              {/* Decorative Line */}
              <div className="flex items-center justify-center relative w-full">
                <div className="w-full">
                  <div className="h-[1px] relative w-full">
                    <div
                      className="absolute inset-0"
                      style={{
                        background: `linear-gradient(90deg, transparent 0%, ${primaryColor} 48%, transparent 100%)`,
                        opacity: 0.995,
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Tabs using ShadCN */}
              <div className="w-full max-md2x:overflow-y-auto">
                <Tabs
                  value={selectedTab}
                  onValueChange={(value) => setSelectedTab(value as "department" | "overall")}
                  className="w-full"
                >
                  <TabsList
                    className="grid w-full grid-cols-2 bg-transparent p-0 gap-3 max-md2x:position-sticky max-md2x:top-0 max-md2x:z-10"
                    style={{
                      background: "transparent",
                    }}
                  >
                    <TabsTrigger
                      value="overall"
                      className="data-[state=active]:bg-transparent data-[state=active]:shadow-none border transition-all duration-200 hover:scale-[1.01] font-rubik font-medium text-xl tracking-[-0.048px] py-3.5 px-3 rounded-sm"
                      style={{
                        borderWidth: "0.548px",
                        borderColor:
                          selectedTab === "overall"
                            ? `rgba(${primaryColorRgb}, 0.5)`
                            : "#000000",
                        color:
                          selectedTab === "overall"
                            ? primaryColor
                            : "rgba(255,255,255,0.5)",
                        boxShadow: "0px 0px 12.485px 0px rgba(0,0,0,0.5)",
                        opacity: selectedTab === "overall" ? 1 : 0.8,
                        background: `linear-gradient(21deg, rgba(${primaryColorRgb}, 0.02) -10.76%, rgba(${primaryColorRgb}, 0.1) 127.18%)`,
                      }}
                    >
                      Overall
                    </TabsTrigger>
                    <TabsTrigger
                      value="department"
                      className="data-[state=active]:bg-transparent data-[state=active]:shadow-none border transition-all duration-200 hover:scale-[1.01] font-rubik font-medium text-xl tracking-[-0.048px] py-3.5 px-3 rounded-sm"
                      style={{
                        borderWidth: "0.548px",
                        borderColor:
                          selectedTab === "department"
                            ? `rgba(${primaryColorRgb}, 0.5)`
                            : "#000000",
                        color:
                          selectedTab === "department"
                            ? primaryColor
                            : "rgba(255,255,255,0.5)",
                        boxShadow: "0px 0px 12.485px 0px rgba(0,0,0,0.5)",
                        opacity: selectedTab === "department" && !isDepartmentEmpty ? 1 : 0.5,
                        background: `linear-gradient(21deg, rgba(${primaryColorRgb}, 0.02) -10.76%, rgba(${primaryColorRgb}, 0.1) 127.18%)`,
                        cursor: isDepartmentEmpty ? 'not-allowed' : 'pointer',
                      }}
                      onClick={handleDepartmentClick}
                      disabled={isDepartmentEmpty}
                    >
                      Department
                    </TabsTrigger>
                  </TabsList>

                    <TabsContent value="overall" className="mt-4 w-full flex flex-col min-h-0" >
                      {/* Leaderboard Table using shadcn */}
                      <div
                        className="
    w-full
  "
                        ref={containerRef}
                      >
                        <div
                          className="box-border flex w-full flex-col content-stretch items-start justify-start overflow-clip rounded-md p-2"
                        style={{
                          backgroundImage: "linear-gradient(90deg, rgba(0, 0, 0, 0.63) 0%, rgba(0, 0, 0, 0.63) 100%)",
                          backgroundSize: "auto, cover",
                          backgroundPosition: "0% 0%, 50% 50%",
                        }}
                      >
                    <Table className="min-w-[540px] lg:min-w-[(800px,100%)] w-full table-fixed">
                      <colgroup>
                        <col className="w-[73px] lg:w-[180px]" />
                        <col className="w-[90px] sm:w-[110px] lg:w-[90px]" />
                        <col className="w-[110px] lg:w-[90px]" />
                        <col className="w-[110px] lg:w-[90px]" />
                        <col className="w-[110px] lg:w-[90px]" />
                      </colgroup>
                            <TableHeader>
                              <TableRow className="border-b-0 hover:bg-transparent">
                          <TableHead className="font-poppins h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]">
                            Player Name
                                </TableHead>
                                <TableHead
                                  className="font-poppins h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] px-4 text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]"
                                  colSpan={2}
                                >
                                  Daily
                                </TableHead>
                                <TableHead
                                  className="font-poppins h-[1.879rem] bg-[rgba(0,0,0,0.5)] px-4 text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]"
                                  colSpan={2}
                                >
                                  All Time
                                </TableHead>
                              </TableRow>
                              <TableRow className="border-b-0 hover:bg-transparent">
                          <TableHead className="h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)]"></TableHead>
                          <TableHead className="font-poppins h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]">
                            Position
                          </TableHead>
                          <TableHead className="font-poppins h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]">
                            Score
                          </TableHead>
                          <TableHead className="font-poppins h-[1.879rem] border-r border-[#3d3d3d] bg-[rgba(0,0,0,0.5)] text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]">
                            Position
                          </TableHead>
                          <TableHead className="font-poppins h-[1.879rem] bg-[rgba(0,0,0,0.5)] text-center text-[11px] sm:text-sm font-semibold text-[#7f7d83]">
                            Score
                          </TableHead>
                        </TableRow>
                      </TableHeader>
                    </Table>
                    <div className="w-full
    overflow-y-auto
                          
                          " 
                          style={{
     maxHeight: "15rem",
  }} >
                      <Table className="min-w-[540px] lg:min-w-[(800px,100%)] w-full table-fixed">
                        <colgroup>
                          <col className="w-[73px] lg:w-[180px]" />
                          <col className="w-[90px] sm:w-[110px] lg:w-[90px]" />
                          <col className="w-[110px] lg:w-[90px]" />
                          <col className="w-[110px] lg:w-[90px]" />
                          <col className="w-[110px] lg:w-[90px]" />
                        </colgroup>
    <TableBody>
  {leaderboardToRender.map((player, index) => {

    /* =====================================================
       ## PLAYER DEBUG
    ===================================================== */



   const playerId = player?.learnerId;



   const isUser =
  String(playerId) === String(currentLearnerId);

 
    return (
      <TableRow
        key={playerId ?? index}
        className="border-b h-[3.188rem]"
        style={{
          borderBottomColor: isUser ? primaryColor : "#3d3d3d",
          borderBottomWidth: "0.751px",
          backgroundColor: isUser
            ? `rgba(${primaryColorRgb},0.15)`
            : "transparent",
          transition: "all 0.25s ease"
        }}
      >
        <TableCell
          className="font-rubik font-semibold text-base pl-[1.691rem] border-r border-[#3d3d3d]"
          style={{ color: isUser ? primaryColor : "#ffffff" }}
        >
          {player.name || player.learnerName || "Guest"}
        </TableCell>

        <TableCell
          className="text-center border-r border-[#3d3d3d]"
          style={{ color: isUser ? primaryColor : "#ffffff" }}
        >
          {player.dailyPosition ?? index + 1}
        </TableCell>

        <TableCell
          className="text-center border-r border-[#3d3d3d]"
          style={{ color: isUser ? primaryColor : "#ffffff" }}
        >
          {player.score ?? 0}
        </TableCell>

        <TableCell
          className="text-center border-r border-[#3d3d3d]"
          style={{ color: isUser ? primaryColor : "#ffffff" }}
        >
          {player.alltimePosition ?? index + 1}
        </TableCell>

        <TableCell
          className="text-center"
          style={{ color: isUser ? primaryColor : "#ffffff" }}
        >
          {player.allTimeScore ?? 0}
        </TableCell>
      </TableRow>
    );
  })}
</TableBody>



                        </Table>
                      </div>
                    </div>
                    </div>
                  </TabsContent>

                  <TabsContent value="department" className="mt-4">
                    {/* Department tab - same structure as overall */}
                    <div 
                      className="relative rounded-[0.564rem] shrink-0 w-full"
                      ref={containerRef}
                    >
                      <div
                        className="box-border content-stretch flex flex-col items-start justify-start overflow-clip p-2 rounded-md w-full"
                        style={{
                          backgroundImage: "linear-gradient(90deg, rgba(0, 0, 0, 0.63) 0%, rgba(0, 0, 0, 0.63) 100%)",
                          backgroundSize: "auto, cover",
                          backgroundPosition: "0% 0%, 50% 50%",
                        }}
                      >
                        <Table className="w-full table-fixed">
                          <TableHeader>
                            <TableRow className="border-b-0 hover:bg-transparent">
                              <TableHead className="text-[#7f7d83] font-poppins font-semibold text-sm text-center bg-[rgba(0,0,0,0.5)] border-r border-[#3d3d3d] h-[1.879rem] w-[10.38rem]">
                                Player Name
                              </TableHead>
                              <TableHead
                                className="text-[#7f7d83] font-poppins font-semibold text-sm text-center bg-[rgba(0,0,0,0.5)] border-r border-[#3d3d3d] h-[1.879rem] px-4"
                                colSpan={2}
                              >
                                Daily
                              </TableHead>
                              <TableHead
                                className="text-[#7f7d83] font-poppins font-semibold text-sm text-center bg-[rgba(0,0,0,0.5)] h-[1.879rem] px-4"
                                colSpan={2}
                              >
                                All Time
                              </TableHead>
                            </TableRow>
                            <TableRow className="border-b-0 hover:bg-transparent">
                              <TableHead className="bg-[rgba(0,0,0,0.5)] border-r border-[#3d3d3d] h-[1.879rem] w-[10.38rem]"></TableHead>
                              <TableHead className="text-[#7f7d83] font-poppins font-semibold text-sm text-center bg-[rgba(0,0,0,0.5)] border-r border-[#3d3d3d] h-[1.879rem] w-24">
                                Position
                              </TableHead>
                              <TableHead className="text-[#7f7d83] font-poppins font-semibold text-sm text-center bg-[rgba(0,0,0,0.5)] border-r border-[#3d3d3d] h-[1.879rem] w-24">
                                Score
                              </TableHead>
                              <TableHead className="text-[#7f7d83] font-poppins font-semibold text-sm text-center bg-[rgba(0,0,0,0.5)] border-r border-[#3d3d3d] h-[1.879rem] w-24">
                                Position
                              </TableHead>
                              <TableHead className="text-[#7f7d83] font-poppins font-semibold text-sm text-center bg-[rgba(0,0,0,0.5)] h-[1.879rem] w-24">
                                Score
                              </TableHead>
                            </TableRow>
                          </TableHeader>
                        </Table>
                        <div className="max-h-[200px] overflow-y-auto w-full overflow-x-hidden">
                          <Table className="w-full table-fixed">


            

     <TableBody>
  {leaderboardToRender.map((player, index) => {

    /* =====================================================
       ## PLAYER DEBUG
    ===================================================== */



   const playerId = player?.learnerId;


   const isUser =
  String(playerId) === String(currentLearnerId);



    return (
      <TableRow
        key={playerId ?? index}
        className="border-b h-[3.188rem]"
        style={{
          borderBottomColor: isUser ? primaryColor : "#3d3d3d",
          borderBottomWidth: "0.751px",
          backgroundColor: isUser
            ? `rgba(${primaryColorRgb},0.15)`
            : "transparent",
          transition: "all 0.25s ease"
        }}
      >
        <TableCell
          className="font-rubik font-semibold text-base pl-[1.691rem] border-r border-[#3d3d3d]"
          style={{ color: isUser ? primaryColor : "#ffffff" }}
        >
          {player.name || player.learnerName || "Guest"}
        </TableCell>

        <TableCell
          className="text-center border-r border-[#3d3d3d]"
          style={{ color: isUser ? primaryColor : "#ffffff" }}
        >
          {player.dailyPosition ?? index + 1}
        </TableCell>

        <TableCell
          className="text-center border-r border-[#3d3d3d]"
          style={{ color: isUser ? primaryColor : "#ffffff" }}
        >
          {player.score ?? 0}
        </TableCell>

        <TableCell
          className="text-center border-r border-[#3d3d3d]"
          style={{ color: isUser ? primaryColor : "#ffffff" }}
        >
          {player.alltimePosition ?? index + 1}
        </TableCell>

        <TableCell
          className="text-center"
          style={{ color: isUser ? primaryColor : "#ffffff" }}
        >
          {player.allTimeScore ?? 0}
        </TableCell>
      </TableRow>
    );
  })}
</TableBody>



                        </Table>
                      </div>
                    </div>
                    </div>
                  </TabsContent>
                </Tabs>
              </div>

              {/* Bottom Navigation */}
              <div className="flex justify-between items-center w-full">
                <NavigationArrow
                  direction="left"
                  // onClick={onScenarioLeaderboardBack}
                   onClick={() => {
        playMenuSound();            // play the sound
    onScenarioLeaderboardBack();    // call the original function
  }}
                  primaryColor={primaryColor}
                />
                <NavigationArrow
                  direction="right"
                  onClick={
                    
                    () => {
                      playMenuSound();
                      handleNextClick();
                    }}
                  primaryColor={primaryColor}
                />
              </div>

              {/* Inset Shadow Border */}
              <div
                className="absolute inset-0 pointer-events-none rounded-[2.375rem]"
                style={{
                  boxShadow: `0px 0px 11px 0px inset rgba(${primaryColorRgb}, 0.3), 0px 0px 20px 0px rgba(${primaryColorRgb}, 0.2)`,
                }}
              />
            </div>
          </div>
        </div>

       
                {/* {showReplayPopup && ( */}
                {shouldShowReplayPopup && (
        
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.25 }}
            className="relative w-full max-w-lg overflow-hidden rounded-3xl p-6 backdrop-blur-[2.5rem]"
          >
            <div className="relative flex flex-col items-center justify-end gap-8">
              {/* Main Content */}
              <div className="flex w-full flex-col gap-6">
                {/* Title */}
                <div
                  className="text-center text-4xl font-normal tracking-[0.005rem]"
                  style={{
                    color: primaryColor,
                    textShadow: `rgba(${hexToRgb(primaryColor)},0.5) 0px 0px 9px`,
                  }}
                >
                  <p>Scenario Review</p>
                </div>
        
                {/* Decorative Line */}
                <div className="relative flex h-[1px] w-full items-center justify-center">
                  <div className="w-full rotate-[179.99deg] scale-y-[-1]">
                    <svg
                      className="block h-[1px] w-full"
                      fill="none"
                      preserveAspectRatio="none"
                      viewBox="0 0 525 1"
                    >
                      <line
                        stroke={`url(#paint0_linear_review_${primaryColor.replace(
                          '#',
                          '',
                        )})`}
                        strokeWidth="0.894962"
                        x2="524.592"
                        y1="0.552519"
                        y2="0.552519"
                      />
                      <defs>
                        <linearGradient
                          gradientUnits="userSpaceOnUse"
                          id={`paint0_linear_review_${primaryColor.replace('#', '')}`}
                          x1="524.592"
                          x2="0"
                          y1="0.999899"
                          y2="0.999919"
                        >
                          <stop stopColor={primaryColor} stopOpacity="0" />
                          <stop
                            offset="0.484375"
                            stopColor={primaryColor}
                            stopOpacity="0.994792"
                          />
                          <stop stopColor={primaryColor} stopOpacity="0" offset="1" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                </div>
        
                {/* Content Text */}
                <div className="z-10 max-h-44 overflow-auto text-center font-rubik text-[1.188rem] font-normal leading-[2.125rem] -tracking-[0.005rem] text-white">
                  {getPopupMessage()}
                </div>
              </div>
        
              {/* Action Buttons */}
              <div className="relative z-10 flex w-full gap-4">
                <Buttons
                  onClick={() => {
    // ## BLOCK API BEFORE ACTION
    isPopupActionRef.current = true;

      handleScenarioReplayButtonClick(
        isBelowMin ? 'mandatoryReplay' : 'optionalReplay',
        data.blockScenario,
      );
       const blockdata = {
                        blockId: data.blockId,
                        blockGameId: data.blockGameId,
                        blockQuestNo: data.blockQuestNo,
                        blockScenario: data.blockScenario,
                        blockSecondaryId: data.blockSecondaryId,
                        blockPrimarySequence: data.blockPrimarySequence,
                        blockDragSequence: data.blockDragSequence,
                        blockShowNavigate: data.blockShowNavigate,
                        blockLeadTo: data.blockLeadTo,
                        blockChoosen: data.blockChoosen,
                      }
                      setlearnerActivityrec((prev:any)=>
                        createOrUpdateStoryBlock(
                          prev,
                          {
                            ...blockdata,
                            replyPromptclose:true,
                            promptscenario : isBelowMin ? 'mandatoryReplay' : 'optionalReplay',
                            replayplayaction : true
                          },
                          deviceInfo
                        )
                      );
    }}
                  variant="ghost"
                  size="sm"
                  className="font-rubik h-12 flex-1 rounded-[2.5rem] px-4 py-2 text-lg font-medium tracking-[0.034rem] text-white transition-all duration-200 hover:scale-110"
                  style={{
                    background: `linear-gradient(100deg, rgba(${hexToRgb(
                      primaryColor,
                    )}) -27.25%, rgba(0, 0, 0, 0.8) 127.803%)`,
                    border: `1px solid rgba(${hexToRgb(primaryColor)}, 0.5)`,
                    boxShadow: `0px 0px 21.786px rgba(${hexToRgb(
                      primaryColor,
                    )}, 0.4)`,
                  }}
                >
                  Replay
                </Buttons>
        
                {!isBelowMin && (
                  <Buttons
                     onClick={() => {
    // ## BLOCK API BEFORE ACTION
    isPopupActionRef.current = true;

        handlePopupNext();
      }}
                    variant="ghost"
                    size="sm"
                    className="font-rubik h-12 flex-1 rounded-[2.5rem] px-4 py-2 text-lg font-medium tracking-[0.034rem] text-white transition-all duration-200 hover:scale-110"
                    style={{
                      background: `rgba(${hexToRgb(primaryColor)}, 0.15)`,
                      border: `1px solid rgba(${hexToRgb(primaryColor)}, 0.35)`,
                      boxShadow: `0px 0px 16px rgba(${hexToRgb(
                        primaryColor,
                      )}, 0.25)`,
                    }}
                  >
                    Next
                  </Buttons>
                )}
              </div>
        
              {/* Background Ellipse Glow */}
              <div className="absolute left-[18rem] h-[24rem] w-[26rem] mix-blend-lighten">
                <div className="absolute inset-[-120%]">
                  <svg className="size-full" fill="none" viewBox="0 0 1250 1210">
                    <g opacity="0.2">
                      <ellipse
                        cx="624.898"
                        cy="604.747"
                        rx="218.898"
                        ry="198.747"
                        fill={primaryColor}
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </div>
        
            {/* Card Inner Shadow */}
            <div className="pointer-events-none absolute inset-0 shadow-[1.58049px_3.16098px_12.6439px_0px_inset_rgba(248,248,248,0.06)]" />
        
            {/* Card Border */}
            <div
              className="pointer-events-none absolute inset-0 rounded-3xl border"
              style={{
                border: `1.18537px solid ${primaryColor}33`,
                boxShadow: `0px 3.16098px 3.16098px rgba(${hexToRgb(
                  primaryColor,
                )}, 0.12)`,
              }}
            />
          </motion.div>
        </div>
        
        )}
      </div>
    </motion.div>
  );
});



export default ScenarioLeaderboard;